/* ---- phones first: a swipeable row of cards ------------------------------- */
.media {
  display: none;
}
.list {
  display: flex;
  gap: var(--sp-4);
  /* Runs to the screen edges, past the container's gutter, so the next card peeks in. */
  margin-inline: calc(-1 * var(--sp-5));
  padding: 0 var(--sp-5) var(--sp-2);
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-padding-inline: var(--sp-5);
  scrollbar-width: none;
}
.row {
  flex: 0 0 min(80%, 22rem);
  display: flex;
  flex-direction: column;
  gap: var(--sp-1);
  overflow: hidden;
  padding-bottom: var(--sp-5);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  background: var(--surface-raised);
  scroll-snap-align: start;
}
.cardImage {
  margin-bottom: var(--sp-2);
}
.rowCode,
.rowTitle,
.rowGets {
  padding-inline: var(--sp-5);
}
/* Holds the row's CodeChip, the same tile as on the 123BIMLive page. */
.rowCode {
  display: flex;
}
.code {
  display: inline-flex;
  align-items: center;
  gap: 0.45em;
  font-size: var(--fs-sm);
  font-weight: 700;
  letter-spacing: 0.04em;
  color: var(--text-muted);
}
/* The analysis's own colour, as on the 123BIMLive page badges. */
.code::before {
  content: "";
  flex: none;
  width: 0.6em;
  height: 0.6em;
  border-radius: 50%;
  background: var(--tint);
}
.rowTitle {
  font-family: var(--font-display);
  font-size: var(--fs-xl);
  font-weight: 600;
  line-height: var(--lh-tight);
  letter-spacing: -0.015em;
  color: var(--text-strong);
}
.rowGets {
  font-size: var(--fs-sm);
  color: var(--text);
}

/* ---- wide screens: a contents page with a sticky preview ------------------ */
@media (min-width: 64rem) {
  .root {
    display: grid;
    grid-template-columns: minmax(0, 5fr) minmax(0, 7fr);
    align-items: start;
    gap: var(--sp-16);
  }
  .media {
    display: block;
    position: sticky;
    /* Clears the floating header. */
    top: calc(var(--header-h) + 2 * var(--header-margin) + var(--sp-6));
  }
  .frame {
    position: relative;
    overflow: hidden;
    aspect-ratio: 16 / 9;
    border-radius: var(--radius-lg);
    background: var(--surface-dark);
    box-shadow: var(--shadow-lg);
  }
  /* Two classes: Picture's `.picture` fill would hide the stacked frames below it. */
  .frame .shot {
    position: absolute;
    inset: 0;
    height: 100%;
    background: none;
  }
  .frame img {
    opacity: 0;
    transition: opacity 450ms var(--ease);
  }
  .frame .shotActive {
    opacity: 1;
  }
  .caption {
    /* Three lines reserved, so a shorter finding doesn't make the page jump. */
    min-height: calc(3 * var(--lh-body) * 1em);
    margin: var(--sp-5) 0 0;
    font-size: var(--fs-md);
    color: var(--text);
  }
  .code {
    margin-right: 0.6em;
    color: var(--text-strong);
  }

  .list {
    display: block;
    margin: 0;
    padding: 0;
    overflow: visible;
    border-top: 1px solid var(--border);
  }
  .row {
    flex-direction: row;
    align-items: center;
    gap: var(--sp-6);
    padding: var(--sp-5) 0;
    overflow: visible;
    border: 0;
    border-bottom: 1px solid var(--border);
    border-radius: 0;
    background: none;
  }
  .cardImage {
    display: none;
  }
  .rowCode,
  .rowTitle,
  .rowGets {
    padding-inline: 0;
  }
  .rowCode {
    flex: none;
    width: 3.75rem;
  }
  .rowTitle {
    font-size: clamp(1.625rem, 0.9rem + 1.6vw, 2.5rem);
    letter-spacing: var(--tracking-heading);
    color: var(--text-muted);
    transition: color var(--dur) var(--ease);
  }
  .row[data-active] .rowTitle {
    color: var(--text-strong);
  }
  /* Shown in the preview's caption; kept here for screen readers, who get the list. */
  .rowGets {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
  }
}
